import React from 'react';
import './loader.css';
const Loader = () => (
    <div className="loader" role="status" aria-live="polite" aria-label="Loading">
        <div className="loader__content">
            <div className="spinner-wrapper">
                <div className="spinner"></div>
                <div className="spinner-ring"></div>
            </div>
            <p className="loader__text">
                Loading
                <span>.</span>
                <span>.</span>
                <span>.</span>
            </p>
        </div>
    </div>
);

export default Loader;
